import { ReactNode, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { resolveRouteTransitionDirection } from "../utils/navigationDirection";
import Home from "../App";
import Idle from "../pages/shared-pages/idle";
import NotFound from "../compoment/NotFound";
import QRCodeForImageUpload from "../pages/shared-pages/upload-image-qr-code";
import ImageTransformationScreen from "../components/ImageTransformationScreen";
import TransformationResultScreen from "../components/TransformationResultScreen";
import SelectArtBackground from "../pages/shared-pages/select-art-background";
import QRScanToPay from "../pages/shared-pages/qr-scan-to-pay";
import PaymentSuccess from "../pages/shared-pages/payment-success";
import OrderConfirmation from "../pages/shared-pages/order-confirmation";
import ThankYou from "../pages/shared-pages/thank-you";
import GlobalPinHandler from "../components/GlobalPinHandler";
import ChooseOption from "../pages/shared-pages/choose-option";
import ChoosePortrait from "../pages/shared-pages/choose-portrait";
import BgRemove from "../pages/shared-pages/bg-remove";
import PrintFrameSelection from "../pages/shared-pages/print-frame-selection";
import AllInnerStation from "../pages/shared-pages/all";
import SelectPeople from "../pages/shared-pages/select-people";
import SelectPeopleCartoon from "../pages/shared-pages/select-people-cartoon";
import SelectMediaLibrary from "../pages/shared-pages/select-media-library";
import ExtractPerson from "../pages/shared-pages/extract-person";
import SelectHobby from "../pages/shared-pages/select-hobby";
import HobbyWriteLine from "../pages/shared-pages/hobby-write-line";
import CreatingPersonHobby from "../pages/shared-pages/creating-person-hobby";
import CreatedPersonHobby from "../pages/shared-pages/created-person-hobby";
import HobbyResultReview from "../pages/shared-pages/hobby-result-review";
import HobbyResultCompare from "../pages/shared-pages/hobby-result-compare";
import SaveFavorite from "../pages/shared-pages/save-favorite";
import SelectFifaCard from "../pages/shared-pages/select-fifa-card/index";
import UploadFifaImage from "../pages/shared-pages/upload-fifa-image/index";
import EnterProfile from "../pages/shared-pages/enter-profile/index";
import FifaStatsChoice from "../pages/shared-pages/fifa-stats-choice/index";
import EnterStats from "../pages/shared-pages/enter-stats/index";
import CreatingFifaCard from "../pages/shared-pages/creating-fifa-card/index";
import SaveFifaCard from "../pages/shared-pages/save-fifa-card/index";
import FifaCardCompare from "../pages/shared-pages/fifa-card-compare/index";
import KioskSessionManager from "../components/KioskSessionManager";
import PWAInstallPrompt from "../components/PWAInstallPrompt";
import KioskInstallPage from "../pages/kiosk-install";
import "./routeTransition.css";

function RouteTransition({ children }: { children: ReactNode }) {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousPathRef = useRef(location.pathname);
  const directionRef = useRef<"forward" | "back">("forward");

  if (previousPathRef.current !== location.pathname) {
    directionRef.current = resolveRouteTransitionDirection(
      previousPathRef.current,
      location.pathname,
      navigationType
    );
    previousPathRef.current = location.pathname;
  }

  const directionClass =
    directionRef.current === "back"
      ? "routeTransition--back"
      : "routeTransition--forward";

  return (
    <div key={location.pathname} className={`routeTransition ${directionClass}`}>
      {children}
    </div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <div className="routeTransitionHost">
      <RouteTransition>
        <Routes location={location}>
          {/* ########## HOME SCREEN ########### */}
          <Route path="/" element={<Home />} />
          <Route path="/kiosk-install" element={<KioskInstallPage />} />
          <Route path="/:slug/all" element={<Idle />} />
          <Route path="/:slug/idle" element={<AllInnerStation />} />
          <Route path="/:slug/choose-option" element={<ChooseOption />} />
          <Route path="/:slug/choose-portrait" element={<ChoosePortrait />} />
          <Route path="/:slug/select-fifa-card" element={<SelectFifaCard />} />
          <Route path="/:slug/upload-fifa-image" element={<UploadFifaImage />} />
          <Route path="/:slug/fifa-stats-choice" element={<FifaStatsChoice />} />
          <Route path="/:slug/enter-stats" element={<EnterStats />} />
          <Route path="/:slug/creating-fifa-card" element={<CreatingFifaCard />} />
          <Route path="/:slug/save-fifa-card" element={<SaveFifaCard />} />
          <Route path="/:slug/fifa-card-compare" element={<FifaCardCompare />} />
          <Route path="/:slug/enter-profile" element={<EnterProfile />} />
          <Route path="/:slug/select-people" element={<SelectPeople />} />
          <Route path="/:slug/select-people-cartoon" element={<SelectPeopleCartoon />} />
          <Route path="/:slug/select-media-library" element={<SelectMediaLibrary />} />
          <Route path="/:slug/extract-person" element={<ExtractPerson />} />
          <Route path="/:slug/select-hobby" element={<SelectHobby />} />
          <Route path="/:slug/hobby-write-line" element={<HobbyWriteLine />} />
          <Route path="/:slug/creating-person-hobby" element={<CreatingPersonHobby />} />
          <Route path="/:slug/hobby-result-review" element={<HobbyResultReview />} />
          <Route path="/:slug/hobby-result-compare" element={<HobbyResultCompare />} />
          <Route path="/:slug/created-person-hobby" element={<CreatedPersonHobby />} />
          <Route path="/:slug/save-favorite" element={<SaveFavorite />} />

          <Route path="/:slug/upload-image-qr-code" element={<QRCodeForImageUpload />} />
          <Route path="/:slug/image-transformation" element={<ImageTransformationScreen />} />
          <Route path="/:slug/bg-remove" element={<BgRemove />} />
          <Route path="/:slug/transformation-result" element={<TransformationResultScreen />} />
          <Route path="/:slug/select-art-background" element={<SelectArtBackground />} />
          <Route path="/:slug/print-frame-selection" element={<PrintFrameSelection />} />

          <Route path="/:slug/qr-scan-to-pay" element={<QRScanToPay />} />
          <Route path="/:slug/payment-success" element={<PaymentSuccess />} />
          <Route path="/:slug/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/:slug/thank-you" element={<ThankYou />} />

          <Route path="/*" element={<NotFound />} />
        </Routes>
      </RouteTransition>
    </div>
  );
}

const AppRoutes = () => {
  return (
    <Router>
      <GlobalPinHandler />
      <PWAInstallPrompt />
      <KioskSessionManager />
      <AnimatedRoutes />
    </Router>
  );
};

export default AppRoutes;
